module.exports = __webpack_public_path__ + "static/media/kfit-mobile-bg.25d6c812.svg";